import type {
  IActionMenuItemTypes,
  IBaseMenuItemProps,
  IDeleteActionMenuItemTypes,
  ILinkMenuItemTypes,
} from "./types";

export const linkMenuItemVariant: {
  [key in ILinkMenuItemTypes]: IBaseMenuItemProps;
} = {
  viewFaculty: {
    title: "viewFaculty",
    iconName: "Eye",
  },
  viewAcademicGroup: {
    title: "viewAcademicGroup",
    iconName: "Eye",
  },
  viewFacultyMember: {
    title: "viewFacultyMember",
    iconName: "Eye",
  },
  viewUserInfo: {
    title: "viewUserInfo",
    iconName: "Eye",
  },
  viewPaper: {
    title: "viewPaper",
    iconName: "Eye",
  },
  viewAchievement: {
    title: "viewAchievement",
    iconName: "Eye",
  },
  viewBook: {
    title: "viewBook",
    iconName: "Eye",
  },
  viewResearchProposal: {
    title: "viewResearchProposal",
    iconName: "Eye",
  },
  viewStudent: {
    title: "viewStudent",
    iconName: "Eye",
  },
  viewNews: {
    title: "viewNews",
    iconName: "Eye",
  },
  viewCourse: { title: "viewCourse", iconName: "Eye" },
  viewChapter: { title: "viewChapter", iconName: "Eye" },
  viewSlide: { title: "viewSlide", iconName: "Eye" },
  viewExam: { title: "viewExam", iconName: "Eye" },
  viewExercise: { title: "viewExercise", iconName: "Eye" },
  viewProject: { title: "viewProject", iconName: "Eye" },
  viewStaff: { title: "viewStaff", iconName: "Eye" },
  editFaculty: {
    title: "editFaculty",
    iconName: "PenNewSquare",
  },
  editAcademicGroup: {
    title: "editAcademicGroup",
    iconName: "PenNewSquare",
  },
  editFacultyMember: {
    title: "editFacultyMember",
    iconName: "PenNewSquare",
  },
  editUserInfo: {
    title: "editUserInfo",
    iconName: "PenNewSquare",
  },
  editPaper: {
    title: "editPaper",
    iconName: "PenNewSquare",
  },
  editAchievement: {
    title: "editAchievement",
    iconName: "PenNewSquare",
  },
  editBook: {
    title: "editBook",
    iconName: "PenNewSquare",
  },
  editResearchProposal: {
    title: "editResearchProposal",
    iconName: "PenNewSquare",
  },
  editStudent: {
    title: "editStudent",
    iconName: "PenNewSquare",
  },
  editNews: {
    title: "editNews",
    iconName: "PenNewSquare",
  },
  editCourse: { title: "editCourse", iconName: "PenNewSquare" },
  editChapter: { title: "editChapter", iconName: "PenNewSquare" },
  editSlide: { title: "editSlide", iconName: "PenNewSquare" },
  editExam: { title: "editExam", iconName: "PenNewSquare" },
  editExercise: { title: "editExercise", iconName: "PenNewSquare" },
  editProject: { title: "editProject", iconName: "PenNewSquare" },
  editStaff: { title: "editStaff", iconName: "PenNewSquare" },
  addChapter: { title: "addChapter", iconName: "AddSquare" },
  addExam: { title: "addExam", iconName: "AddSquare" },
  addExercise: { title: "addExercise", iconName: "AddSquare" },
  addSlide: { title: "addSlide", iconName: "AddSquare" },
  addProject: { title: "addProject", iconName: "AddSquare" },
};

export const actionMenuItemVariant: {
  [key in IActionMenuItemTypes]: IBaseMenuItemProps;
} = {
  sendMessageToUser: {
    title: "sendMessageToUser",
    iconName: "Dialog",
  },
  addRoleToMember: {
    title: "addRoleToMember",
    iconName: "UserCheck",
  },
};

export const deleteActionMenuItemVariant: {
  [key in IDeleteActionMenuItemTypes]: IBaseMenuItemProps;
} = {
  deleteAcademicGroup: {
    title: "deleteAcademicGroup",
  },
  deleteUser: {
    title: "deleteUser",
  },
  deleteFaculty: {
    title: "deleteFaculty",
  },
  deleteFacultyMember: {
    title: "deleteFacultyMember",
  },
  deletePaper: {
    title: "deletePaper",
  },
  deleteAchievement: {
    title: "deleteAchievement",
  },
  deleteBook: {
    title: "deleteBook",
  },
  deleteResearchProposal: {
    title: "deleteResearchProposal",
  },
  deleteStudent: {
    title: "deleteStudent",
  },
  deleteNews: {
    title: "deleteNews",
  },
  deleteCourse: {
    title: "deleteCourse",
  },
  deleteChapter: {
    title: "deleteChapter",
  },
  deleteExam: {
    title: "deleteExam",
  },
  deleteExercise: {
    title: "deleteExercise",
  },
  deleteProject: {
    title: "deleteProject",
  },
  deleteSlide: {
    title: "deleteSlide",
  },
  deleteStaff: {
    title: "deleteStaff",
  },
  deleteStaffRole: {
    title: "removeStaffRole",
    showAlertProps: {
      title: "deleteRoleAlert.staffFromMember",
      type: "delete",
    },
  },
  deleteDepartmentStaffRole: {
    title: "removeDepartmentStaffRole",
    showAlertProps: {
      title: "deleteRoleAlert.departmentStaffFromMember",
      type: "delete",
    },
  },
};
